import React from 'react';
import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconSocialFacebookDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><g clipPath="url(#social-facebook-default_svg__a)"><path fill="currentColor" d="M22 12.561C22 7.005 17.523 2.5 12 2.5S2 7.005 2 12.561c0 5.022 3.657 9.184 8.438 9.939v-7.03h-2.54V12.56h2.54v-2.216c0-2.522 1.492-3.915 3.777-3.915 1.093 0 2.238.197 2.238.197v2.476h-1.26c-1.243 0-1.63.775-1.63 1.572v1.886h2.773l-.443 2.908h-2.33V22.5c4.78-.755 8.437-4.917 8.437-9.939" /></g><defs><clipPath id="social-facebook-default_svg__a"><path fill="currentColor" d="M2 2.5h20v20H2z" /></clipPath></defs></svg></>;
}
export default IconSocialFacebookDefault;